import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormModule } from '../form/form.module';
import { PreloaderModule } from '../preloader/preloader.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { SearchFieldComponent } from './search-field.component';

@NgModule({
  declarations: [SearchFieldComponent],
  imports: [CommonModule, FormModule, SvgIconModule, PreloaderModule],
  exports: [SearchFieldComponent]
})
export class SearchFieldModule {}

export * from './search-field.component';
